import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { IStore } from '../../../../../redux/store';
import ORB4Previewer from './ORB4Previewer';
import { TORB4BackendRecord } from 'redux/app/orb4/@types';
import ORB4AttachmentsPrintView from './ORB4AttachmentsPrintView';
import ORB4RecordParticipantsView from './ParticipantsView';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    orb4Records: TORB4BackendRecord[];
    isPrintVisible: boolean;
	vesselId: string;
};
type ORB4PrintProps = OwnProps & PropsFromRedux;
function ORB4Print(props: ORB4PrintProps) {
    const { isPrintVisible, orb4Records } = props;
    if (!isPrintVisible) return null;
    return (
        <div className="w-full p-4">
            <div className="mb-8">
                <h3 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                    Cargo/Ballast Operations. <i>(OIL TANKERS)</i>
                </h3>
            </div>
            <div className="w-full bg-gray-100">
                <table className="w-full bg-gray-100 wayship-table-light orb4-table">
                    <thead>
                        <tr className="theader">
                            <th>
                                <div
                                    style={{ width: 100, textAlign: 'center' }}
                                    className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600  border-gray-300 whitespace-nowrap"
                                >
                                    Date{' '}
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300 whitespace-nowrap min-w-20">
                                    <p>Code</p>
                                    <p className="m-0">(Letter)</p>
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600  border-gray-300 whitespace-nowrap min-w-20">
                                    <p>Item</p>
                                    <p className="m-0">(number)</p>
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600  border-gray-300 whitespace-nowrap min-w-20">
                                    Record of operations/signature of officer in
                                    charge
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orb4Records.map((orbRecord, index) => {
                            const isSubmitterChiefOrMaster =
                                orbRecord.approvedBy
                                    ? orbRecord.approvedBy.staffId ===
                                      orbRecord.submittedBy?.staffId
                                    : false;
                            return (
                                <React.Fragment key={orbRecord._id}>
                                    <ORB4Previewer
                                        orbRecord={orbRecord}
                                        theme="light"
                                    />
                                    <ORB4AttachmentsPrintView
                                        orb4Record={orbRecord}
                                    />
                                    <ORB4RecordParticipantsView
                                        isSubmitterChiefOrMaster={
                                            isSubmitterChiefOrMaster
                                        }
                                        orb4Record={orbRecord}
                                        theme="light"
                                    />
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        vesselName: vesselInfo?.vesselName,
        imoNumber: vesselInfo?.imoNumber,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB4Print);
